// This code defines a function called `checkHighlightTags()` that takes a
// highlight tag as input and shows or hides all the card wrappers that
// contain that highlight tag.

document.addEventListener("DOMContentLoaded", () => {
  // Smooth accordion animation for product highlights
  class AccordionRow {
    constructor(el, allRows) {
      this.el = el;
      this.header = el.querySelector(".highlight-title");
      this.content = el.querySelector(".accepted-answer");
      this.allRows = allRows;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.header.addEventListener("click", (e) => this.onClick(e));
      // Keyboard accessibility: toggle on Enter or Space
      this.el.addEventListener("keydown", (e) => {
        if (
          e.key === "Enter" ||
          e.key === " " ||
          e.keyCode === 13 ||
          e.keyCode === 32
        ) {
          e.preventDefault();
          this.onClick(e);
        }
      });
      // Handle initial open state
      if (this.el.classList.contains("open")) {
        this.content.style.maxHeight = this.content.scrollHeight + "px";
        this.isExpanding = false;
        this.isClosing = false;
        this.animation = null;
      } else {
        this.content.style.maxHeight = null;
      }
    }

    onClick(e) {
      e.preventDefault();
      if (this.el.classList.contains("open")) {
        this.shrink();
      } else {
        // Always close others before expanding this one
        this.allRows.forEach((row) => {
          if (row !== this) row.shrink(true);
        });
        this.expand();
      }
      // Update product cards
      const clickedHighlight = this.el.getAttribute("data-highlight-tag");
      checkHighlightTags(clickedHighlight);
    }

    shrink(skipAnimation = false) {
      if (!this.el.classList.contains("open")) return;
      this.isClosing = true;
      this.el.classList.remove("open");
      this.el.setAttribute("aria-expanded", "false");
      if (this.animation) this.animation.cancel();
      const startHeight = this.content.scrollHeight;
      if (skipAnimation) {
        this.content.style.maxHeight = null;
        this.isClosing = false;
        return;
      }
      this.content.style.maxHeight = startHeight + "px";
      this.animation = this.content.animate(
        {
          maxHeight: [startHeight + "px", "0px"],
        },
        { duration: 300, easing: "ease-out" }
      );
      this.animation.onfinish = () => {
        this.content.style.maxHeight = null;
        this.isClosing = false;
        this.animation = null;
      };
      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }

    expand() {
      if (this.el.classList.contains("open")) return;
      this.isExpanding = true;
      this.el.classList.add("open");
      this.el.setAttribute("aria-expanded", "true");
      if (this.animation) this.animation.cancel();
      const endHeight = this.content.scrollHeight;
      this.content.style.maxHeight = "0px";
      // Force reflow to apply the 0px before animating
      void this.content.offsetWidth;
      this.animation = this.content.animate(
        {
          maxHeight: ["0px", endHeight + "px"],
        },
        { duration: 300, easing: "ease-out" }
      );
      this.animation.onfinish = () => {
        this.content.style.maxHeight = endHeight + "px";
        this.isExpanding = false;
        this.animation = null;
      };
      this.animation.oncancel = () => {
        this.isExpanding = false;
      };
    }
  }

  // Product card filtering logic (unchanged)
  function checkHighlightTags(clickedHighlight) {
    var highlightWrappers = document.querySelectorAll(".highlights__wrapper");
    highlightWrappers.forEach(function (highlightWrapper) {
      var cardWrappers = document.querySelectorAll(
        ".product-wrapper--desk .product_card"
      );
      cardWrappers.forEach(function (cardWrapper) {
        var highlightTags = (
          cardWrapper.getAttribute("data-highlight-tag") ?? ""
        ).split(",");
        var isMatched = highlightTags.some(
          (tag) => tag.trim() === clickedHighlight.trim()
        );
        cardWrapper.style.display = isMatched ? "block" : "none";
      });
    });
  }

  const detailsElements = Array.from(
    document.querySelectorAll(".highlights__wrapper .accordion-row")
  );
  const accordions = detailsElements.map((el) => new AccordionRow(el, []));
  // Set allRows reference for each instance
  accordions.forEach((acc) => (acc.allRows = accordions));

  // Open the first accordion by default if none is open
  if (!detailsElements.some((el) => el.classList.contains("open"))) {
    const first = detailsElements[0];
    if (first) {
      first.classList.add("open");
      const content = first.querySelector(".accepted-answer");
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }
  // Sync product cards to the open accordion
  const openRow = detailsElements.find((el) => el.classList.contains("open"));
  if (openRow) {
    const clickedHighlight = openRow.getAttribute("data-highlight-tag");
    checkHighlightTags(clickedHighlight);
  }
});
